const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverviewOutflow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F8EBEA",
    style: {
      fill: "#F8EBEA",
      fill: "color(display-p3 0.9725 0.9216 0.9176)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0835 23.0417C18.0835 24.1734 18.9585 25.0834 20.0318 25.0834H22.2251C23.1585 25.0834 23.9168 24.29 23.9168 23.2984C23.9168 22.2367 23.4502 21.8517 22.7618 21.6067L19.2502 20.3817C18.5618 20.1367 18.0952 19.7634 18.0952 18.69C18.0952 17.71 18.8535 16.905 19.7868 16.905H21.9802C23.0535 16.905 23.9285 17.815 23.9285 18.9467",
    stroke: "#961D14",
    style: {
      stroke: "#961D14",
      stroke: "color(display-p3 0.5882 0.1144 0.0784)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15.75V26.25",
    stroke: "#961D14",
    style: {
      stroke: "#961D14",
      stroke: "color(display-p3 0.5882 0.1144 0.0784)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6668 20.9999C32.6668 27.4399 27.4402 32.6666 21.0002 32.6666C14.5602 32.6666 9.3335 27.4399 9.3335 20.9999C9.3335 14.5599 14.5602 9.33325 21.0002 9.33325",
    stroke: "#961D14",
    style: {
      stroke: "#961D14",
      stroke: "color(display-p3 0.5882 0.1144 0.0784)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 13.9999V9.33325H28",
    stroke: "#961D14",
    style: {
      stroke: "#961D14",
      stroke: "color(display-p3 0.5882 0.1144 0.0784)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8335 15.1666L32.6668 9.33325",
    stroke: "#961D14",
    style: {
      stroke: "#961D14",
      stroke: "color(display-p3 0.5882 0.1144 0.0784)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewOutflow);
export default __webpack_public_path__ + "static/media/overview-outflow.4b02887bbf1879f6a46e2db09c7a414c.svg";
export { ForwardRef as ReactComponent };